<!-- 【画面名】設問入力画面 -->

<template>
  <CommonHeader />
  <div id="entry-question-wait" class="entry-question-wait">

    <div class="content">

      <div class="message-area">
        <h3 class="top-text" v-if="topText" v-html='topText'></h3>
      </div>

      <div id="errtext" class="errmsg" v-if="errorMessage" v-html='errorMessage'></div>
      <div class="defmsg" v-if="multipleMessage" v-html='multipleMessage'></div>

      <div class="question-content">
        <div class="question-item">
          <div class="question-text" v-if="questionText" v-html='questionText'></div>

          <!-- ラジオボタン設問 -->
          <div class="choices-list-radio" v-if="formType == 1">
            <p v-for="choicesItem in choicesList" :key="choicesItem.choice_no">
            <input type="radio" v-bind:id="'r-'+choicesItem.choice_no" name="radio-item" v-bind:value="choicesItem.choice_no" v-model="answer" />
            <label v-bind:for="'r-'+choicesItem.choice_no">{{choicesItem.choices}}</label>
            </p>
          </div>

          <!-- プルダウン設問 -->
          <div class="choices-list-select" v-if="formType == 2">
            <select name="select-item" v-model="answer">
            <option value="">選択して下さい</option>
            <option v-for="choicesItem in choicesList" :key="choicesItem.choice_no" v-bind:value="choicesItem.choice_no">{{choicesItem.choices}}</option>
            </select>
          </div>

        </div>

        <div class="submit-button"><button name="submit" type="submit" v-text='buttonName' v-on:click="questionSubmit"></button></div>
      </div>

      <div class="foot-text" v-if="footText" v-html='footText'></div>
    </div>
    <!-- /.content -->

    <div class="multiple-popup" v-bind:class="popupClassName">
      <div class="popup-layer" v-on:click="hidePopup"></div>
      <div class="multiple-popup-inner">
        <div class="popup">
          <div class="text">回答を受付けました</div>
          <div class="btn" v-on:click="hidePopup">設問画面へ戻る</div>
        </div>
      </div>
    </div>

  </div>
  <CommonFooter />
</template>

<script>
/* eslint-disable */
import CommonHeader from './CommonHeader.vue'
import CommonFooter from './CommonFooter.vue'
import axios from 'axios';

export default {
  name: 'EntryQuestion',
  components: {
    CommonHeader,
    CommonFooter,
  },
  data() {
    return {
      topText: '',
      footText: '',
      buttonName: '送信する',
      formType: '',
      questionInfo: [],
      questionText: '',
      choicesList: [],
      questionNo: '',
      correctAnswerChoice: '',
      score: 0,
      answer: '',
      nowQuestionNo: '',
      anserValue: {},
      basicInfo: [],
      errorMessage: '',
      fileCreatedAt: '',
      publishedAt: '',
      urlKey: '',
      salt: '',
      apiUrl: '',
      popupClassName: '',
      multipleMessage: '',
      questionSettingUpdatedAt: '',
      isLast: 0,
    }
  },
  inject: ['voteScreanInfo', 'getJson', 'viewScrean', 'encryptSha256', 'getUrlKey', 'getReservedWord'],
  mounted(){ // ページが読み込まれたらする処理
    // console.log(this.voteScreanInfo);
    this.apiUrl = process.env.VUE_APP_API_DOMAIN
    this.salt = process.env.VUE_APP_VOTE_SCREEN_HASH_SALT


    this.basicInfo = this.voteScreanInfo[0].basic_info;
    var reservedWord = this.voteScreanInfo[0].reserved_word;
    this.questionInfo = this.voteScreanInfo[0].question_info;
    var displayInfo = this.voteScreanInfo[0].display_info;
    this.fileCreatedAt = this.voteScreanInfo[0].file_created_at; // 投票画面情報ファイル生成日時
    this.publishedAt = this.voteScreanInfo[0].published_at;
    this.urlKey = this.getUrlKey(); // URLキー
    this.questionSettingUpdatedAt = this.voteScreanInfo[0].question_setting_updated_at;

    // 上部下部テキスト設置
    this.topText = this.getReservedWord(displayInfo.question_information.qs_top_text);
    this.footText = this.getReservedWord(displayInfo.question_information.qs_bottom_text);
    this.buttonName = displayInfo.question_information.qs_button_name;

    // 設問設置
    var nowQuestionData = this.questionInfo[0];
    this.questionText = nowQuestionData.sentence;
    this.formType = nowQuestionData.form_type;
    this.choicesList = nowQuestionData.choices_list;
    this.correctAnswerChoice = nowQuestionData.correct_answer_choice;
    this.questionNo = nowQuestionData.question_no; // 設問No
    this.isLast = nowQuestionData.is_last;

    if(nowQuestionData.score) {
      this.score = nowQuestionData.score;
    }


    // すでに回答済みで多重投票ありの場合メッセージ表示
    var nowQuestionAnswerd = false;
    var cookieData = this.$cookies.get('nhk_'+this.basicInfo.program_frame_id);
    if(cookieData) {
      if(cookieData.answered_question_num.indexOf(this.questionNo) > -1) {
        nowQuestionAnswerd = true;
      }
    }
    if(this.basicInfo.can_multiple_vote == 1 && nowQuestionAnswerd == true) {
      this.multipleMessage = '回答を受け付けました。こちらの設問は複数回回答が可能です。';
    }

  },

  methods: { // 使い回す関数
    questionSubmit() {
      var programCookieKey ='nhk_'+ this.basicInfo.program_frame_id + '_' + this.basicInfo. program_id;
      var cookieData = this.$cookies.get(programCookieKey);
      var answerdFlg = false;
      var res = 0; 

      // クイズ投票で設問締め切り後に投票された場合→設問待ち画面でエラー表示
      if(this.basicInfo.mode == 2 && !this.questionInfo.length) {
        // console.log('error no question');
        this.getJson('timeoutError');
        return;
      }

      // 特定の条件でCookieクリア
      // if(cookieData) {
        // if(cookieData.question_setting_updated_at) {
          // if(cookieData.question_setting_updated_at != this.questionSettingUpdatedAt) {
          // console.log('Cookie削除');
            // $cookies.remove(programCookieKey);
          // }
        // }
      // }

      if(this.answer) {

        if(this.basicInfo.can_multiple_vote == 1) {
          this.popupClassName = 'show';
        }

        // 投票データをDBにPOST
        // this.postVoteValue(31, this.questionNo, this.answer);
        var sysid = Number(this.basicInfo.program_frame_id.replace('vote', ''));
        this.postVoteValue(sysid, this.questionNo, this.answer);

        //設問No ＋ 設問選択肢No ＋ 番組枠ID ＋ URLキー ＋ 投票画面情報ファイル生成日時 ＋ ソルト(固定文字列)
        var answerHashKey = this.questionNo.toString() + this.answer.toString() + this.basicInfo.program_frame_id + this.urlKey + this.fileCreatedAt + this.salt;
        var answerHash = this.encryptSha256(answerHashKey).toString();
        if(answerHash == this.correctAnswerChoice) {
         res = 1;
        }

        this.errorMessage = '';
        var cookieDataArray = [];

        // 投票クッキーがあればその値を更新
        if(cookieData && cookieData.answered_last_num) {

          var cookieDataArray = cookieData;
          var answer = {q: this.questionNo, a: this.answer, res:res, score:this.score};
         
          // 回答した設問ナンバーの配列生成
          if(cookieDataArray.answered_question_num.indexOf(this.questionNo) == -1) {
            cookieDataArray.answered_question_num.push(this.questionNo);
          }

          // 最後に回答した最大設問ナンバーを代入
          // if(cookieDataArray && this.questionNo > cookieDataArray.answered_last_num) {
          cookieDataArray.answered_last_num = this.questionNo;
          // }

          // 最後の設問かどうか値を代入
          if(this.isLast > cookieDataArray.is_last) {
            cookieDataArray.is_last = this.isLast;
          }

          for(const answer of cookieDataArray.answers) {
            // すでに回答済みの設問への回答（上書き）
            if(answer.q == this.questionNo) {
              answer.a = this.answer;
              answerdFlg = true;
              if(this.basicInfo.can_multiple_vote == 1) {
                answer.res = res;
              } else {
                this.errorMessage = '既に本質問に回答済みです。';
              }
            }
          }

          // クッキーデータの中に現在の設問ナンバー（回答）がなかったら回答データをプッシュ
          if(answerdFlg == false) {
            cookieDataArray.answers.push(answer);
          }

        } else {
          // 投票クッキーがなければ新規作成
          var answers = [];
          var answer = {q: this.questionNo, a: this.answer, res:res, score:this.score};
          answers.push(answer);

          var cookieDataArray = {
            'sisid': this.basicInfo.program_frame_id,
            'answered_last_num': this.questionNo,
            'answered_question_num': [this.questionNo],
            'answers' : answers,
            'is_last' : this.isLast,
            'published_at' : this.publishedAt,
            'first_answerd' : 1
          }

            this.postVoteValue(sysid, 99, 1);
        }

        // console.log('cookie登録 entry');
        // console.log(cookieDataArray);
        var cookieDataString = JSON.stringify(cookieDataArray);
        this.$cookies.set(programCookieKey, cookieDataString);
        this.viewScrean(true);

      } else {

        this.errorMessage = '回答を選択してください。';

      }
    },

    postVoteValue(sysid, q, a) {
      if(!sysid || !q || !a) return;

      var postVal = {
        sysid: sysid,
        q: q,
        a: a,
        // sid: '',
        // exval: '',
      };
      // console.log('投票APIへPOST');
      // console.log(postVal);

      axios.post(this.apiUrl, postVal)
      .then(
        response => {
          // console.log('投票APIレスポンス');
          // console.log(response);
        }
      )
      .catch(
        error => {
          console.log('Axios Error');
          console.log(error);
        }
      );

    },

    hidePopup() {
      if(this.popupClassName == 'show') {
        this.popupClassName = '';
        this.multipleMessage = '回答を受け付けました。こちらの設問は複数回回答が可能です。';
      }
    },


  },
}
/* eslint-disable */
</script>
